export default {"src":"/_next/static/media/logoWithoutTxt.bbf1095d.svg","height":48,"width":62,"blurWidth":0,"blurHeight":0};